
export const S3_URL="https://catering.nagskitchen.net/publicimages/";

